'use strict';

/**
 * Implementation for drag and drop functionallity for touch- and non-touch devices.
 *
 * Inspired by:
 * * Slip.js (https://github.com/pornel/slip/)
 *
 * @copyright  Copyright (c) 2014, humans and machines (http://humansandmachines.de)
 * @author     Stefan Rueschenberg <sr@humansandmachines.de>
 */
;(function ($, win, doc, undefined) {
    'use strict';

    // Ensure namespace
    win.Humans = win.Humans || {};

    /**
     * Definition of the DndManager
     * The DndManager will manage the interactions between humansDrag and humansDrop.
     * @type {object}
     */
    win.Humans.DndManager = {
        /**
         * Object, that is holding all registred droppables
         * @type {object}
         */
        droppables: {},

        /**
         * Instance of the currentdrag, if present
         * @type {null|humansDrag}
         */
        currentDrag: null,

        /**
         * Prepares the offsets and dimensions of the humansDrops in relation to the current scope of the humansDrag.
         * @param {object}     e          The event, that caused this function call
         * @param {humansDrag} humansDrag The instance of the current drag element
         */
        prepareOffsets: function(e, humansDrag) {
            var humansDrops = win.Humans.DndManager.droppables[humansDrag.options.scope] || [];

            // Loop through all drops
            for (var i = 0; i < humansDrops.length; i++) {
                // @todo: Add behavior for nested drops

                // Check visibility
                humansDrops[i].visible = humansDrops[i].$el.css("display") !== "none";
                if (!humansDrops[i].visible) {
                    continue;
                }

                // Check, if offset should be recalculated for drop
                if (!humansDrops[i].options.refreshPosDim) {
                    continue;
                }

                // Check acceptance
                if (!humansDrops[i].accept(humansDrops[i].el, humansDrag.getTargetElement(true))) {
                    continue;
                }

                // Everything fine? -> Refresh
                humansDrops[i]._renewPosAndDimension();
            }
        },

        /**
         * Sets the given humansDrag as current dragElement
         * @param {humansDrag} humansDrag The instance of the drag element to set
         */
        setDragElement: function(humansDrag) {
            this.currentDrag = humansDrag;
        },

        /**
         * Is called every time a new humansdrag has started to drag.
         * @param {object}     e          The event, that caused this function call
         * @param {humansDrag} humansDrag The instance of the current drag element
         */
        dragStart: function(e, humansDrag) {
            this.prepareOffsets(e, humansDrag);
        },

        /**
         * The drag method is called everytime the drag moves around.
         * @param {object}     e          The event, that caused this function call
         * @param {humansDrag} humansDrag The instance of the current drag element
         * @return {boolean} True, if drag is over valid drop
         */
        drag: function(e, humansDrag) {
            var scope = humansDrag.options.scope,
                intersects = false,
                humansDrop = null,
                isOverDrop = false;


            // Handle scroll
            this.handleScroll(humansDrag);

            // Refresh offsets
            this.prepareOffsets(e, humansDrag);

            // Loop through all relevant drops
            var humansDrops = win.Humans.DndManager.droppables[scope] || [];
            for (var i = 0; i < humansDrops.length; i++) {
                humansDrop = humansDrops[i];

                // Just check, if the humansdrop is visible
                if (!humansDrop.visible) {
                    continue;
                }

                // Could drag be dropped?
                if (!humansDrag.couldDrop()) {
                    continue;
                }

                // Check intersection
                intersects = win.Humans.DndManager.intersect(humansDrag, humansDrop, humansDrop.options.tolerance, e);

                if (intersects) { // Drag is over drop
                    if (!humansDrop.isOver) { // Drag was not over before
                        humansDrop._enter.call(humansDrop, e);
                    }

                    // Call genereal over
                    humansDrop._over.call(humansDrop, e);

                    isOverDrop = true;
                } else { // Drag is not over drop
                    if (humansDrop.isOver) { // Drag was over drop before
                        humansDrop._leave.call(humansDrop, e)
                    }
                }
            }

            return isOverDrop;
        },

        /**
         * Is called from the humansDrag, if the drag process was stopped.
         * Theis function will return true, if the drag was dropped on a valid drop.
         * @param {object}     e          The event, that caused this function call
         * @param {humansDrag} humansDrag The instance of the current drag element
         * @returns {boolean}  True if the drag was released on a valid droppable
         */
        drop: function(e, humansDrag) {
            var dropped = false,
                scope = humansDrag.options.scope,
                humansDrop = null;

            var humansDrops = win.Humans.DndManager.droppables[scope] || [];
            for (var i = 0; i < humansDrops.length; i++) {
                humansDrop = humansDrops[i];

                // Just check, if the humansdrop is visible
                if (!humansDrop.visible) {
                    continue;
                }

                // Could drag be dropped?
                if (!humansDrag.couldDrop()) {
                    continue;
                }

                if (win.Humans.DndManager.intersect(humansDrag, humansDrop, humansDrop.options.tolerance, e)) {
                    dropped = humansDrop._drop.call(humansDrop, e) || dropped;
                }
            }

            return dropped;
        },

        /**
         * Is called right after the drop method.
         * @param {object}     e          The event, that caused this function call
         * @param {humansDrag} humansDrag The instance of the current drag element
         */
        dragEnd: function(e, humansDrag) { /* Stub */},

        /**
         * Intersects the position between the humansDrag and humansDrop.
         * It will return true, if the humansDrop is over the humansDrag.
         * @param {humansDrag}   humansDrag The instance of the current drag element
         * @param {humansDrop}   humansDrop The instance of the current drop element
         * @param {object}       e          The event, that has called the intersection
         * @returns {boolean} True, if the dragelement is over the dropelement
         */
        intersect: function(humansDrag, humansDrop, e) {
            function isOverAxis(x, reference, size) {
                return (x >= reference) && (x < (reference + size));
            }

            return isOverAxis(humansDrag.currentPosition.yR, humansDrop.offset.top, humansDrop.dimensions.h)
                && isOverAxis(humansDrag.currentPosition.xR, humansDrop.offset.left, humansDrop.dimensions.w);
        },

        /**
         * Handles the scroll of container, when the drag element comes to the edge of the container
         * @param {humansDrag} humansDrag The instance of the current drag element
         */
        handleScroll: function(humansDrag) {
            var scrollContainerObject,
                scrollContainer;

            if (humansDrag.scrollContainer.length) {
                for (var i = 0; i < humansDrag.scrollContainer.length; i++) {
                    scrollContainer = humansDrag.scrollContainer[i];
                    scrollContainerObject = {
                        offset: scrollContainer.offset(),
                        dimensions: {
                            w: scrollContainer[0].offsetWidth,
                            h: scrollContainer[0].offsetHeight
                        }
                    };

                    // Check for intersection
                    if (win.Humans.DndManager.intersect(humansDrag, scrollContainerObject)) {
                        var dp = humansDrag.currentPosition.yR,
                            containerTop = scrollContainerObject.offset.top,
                            containerHeight = scrollContainerObject.dimensions.h,
                            area = Math.round(containerHeight / 100 * 15),
                            topRange = {
                                top: containerTop,
                                bottom: containerTop + area
                            },
                            bottomRange = {
                                top: containerTop + containerHeight - area,
                                bottom: containerTop + containerHeight
                            },
                            scrollTop = scrollContainer.scrollTop();

                        // Scrolling up
                        if (dp >= topRange.top && dp <= topRange.bottom) {
                            var rel = Math.abs(dp - topRange.bottom) / area * humansDrag.options.scrollAcceleration;
                            scrollTop -= Math.ceil(rel);
                        }

                        // Scrolling down
                        if (dp >= bottomRange.top && dp <= bottomRange.bottom) {
                            var rel = Math.abs(dp - bottomRange.top) / area * humansDrag.options.scrollAcceleration;
                            scrollTop += Math.ceil(rel);
                        }

                        // Apply scroll
                        if (scrollTop >= 0 && scrollTop <= scrollContainer[0].scrollHeight) {
                            scrollContainer.scrollTop(scrollTop);
                        }
                    }
                }
            }
        }
    };


    var pluginNameDrag = "humansDrag",
        defaultsDrag = {
            scope: 'default', // Scope for interaction between drags and drops
            touchHoldThreshold: 10, // Threshold distance when item should be dragged
            mouseHoldThreshold: 5, // Threshold distance when item should be dragged
            allowTextSelection: false, // Should textselection be disabled?
            holdTimeoutTouch: 250, // Hold timeout for touch devices
            holdTimeoutMouse: 20, // Hold timeout for mouse devices
            helper: 'clone', // Type of the helper
            helperClass: false, // Additional class for the drag helper
            helperContainer: 'body', // Where to append the drag helper?
            revert: true, // Revert on non drop?
            revertClass: false, // Class to apply, when drag is reverted to start position
            revertOnDrop: false, // Revert the item on drop?
            dropClass: false, // Class for the drag, when it was dropped
            overDropClass: false, // Class for the drag, when it is over the drop
            vibrateTime: 50, // Vibrate time for tables
            offset: [0, 0], // Offset for visual response
            keepSize: true, // Try to keep the helper size as the original item
            dropThreshold: 50, // Pixel, after drag could be dropped
            scrollContainer: [], // Selector for scrollcontainer
            scrollAcceleration: 20, // Acceleration for scrolling
            delegate: null, // Delegate event to child?
            preventLinks: true, // Prevent link clicks

            onInteractionStart: function(event, humansDrag, element) { /* Stub for callback */ },
            onInteractionEnd: function(event, humansDrag, element) { /* Stub for callback */ },
            onDragStart: function(event, humansDrag, element, helper) { /* Stub for callback */ },
            onDrag: function(event, humansDrag, element, helper) { /* Stub for callback */ },
            onOverDrop: function(event, humansDrag, element, helper) { /* Stub for callback */ },
            onDrop: function(event, humansDrag, element, helper) { /* Stub for callback */ },
            onDragEnd: function(event, humansDrag, element, helper) { /* Stub for callback */ },
            onEnable: function(humansDrag) { /* Stub for callback */ },
            onDisable: function(humansDrag) { /* Stub for callback */ },
        };

    /**
     * Definition of the humansDrop Plugin
     * @param {HTMLElement} element The HTML element to use
     * @param {object}      options The options to apply for this drag
     * @constructor
     */
    function humansDrag(element, options) {
        // Ref to element
        this.el  = element;
        this.$el = $(element);

        // Ref to drag element
        this.dragEl  = null;
        this.$dragEl = null;

        // Settings
        this.options   = $.extend({}, defaultsDrag, options);
        this._defaults = defaultsDrag;
        this._name     = pluginNameDrag;

        // Init drag
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(humansDrag.prototype, {

        POINTER_MOUSE: 'mouse',
        POINTER_TOUCH: 'touch',

        STATES: {
            IDLE: 'idle',
            INTERACTION: 'interaction',
            DRAG: 'drag',
            DRAGEND: 'dragend',
        },

        /**
         * Throttle for updating position
         * @type {number}
         */
        throttle: 20,

        /**
         * Throttle timing
         * @type {number}
         */
        throttleTime: 0,

        /**
         * Current state
         * @type {string}
         */
        state: 'idle',

        /**
         * Is dnd currently active?
         * @type {boolean}
         */
        enabled: true,

        /**
         * Are we using touch events?
         * @type {boolean}
         */
        isUsingTouch: false,

        /**
         * Are the mousehandlers attached?
         * @type {boolean}
         */
        mouseHandlersAttached: false,

        /**
         * Reference to the dnd clone
         * @type {Array}
         */
        helper: [],

        /**
         * Start position of the drag
         * @type {object|null}
         */
        startPosition: null,

        /**
         * Last position of the drag
         * @type {object|null}
         */
        lastPosition: null,

        /**
         * Indicates, if the element was dropped on a valid humansDrop
         * @type {boolean}
         */
        wasDropped: false,

        /**
         * Scrollcontainer to watch for scrolling
         * @type {Array}
         */
        scrollContainer: [],

        /**
         * Scrolloffset of the container, that contains the drag element
         * @type {number}
         */
        scrollOffset: 0,

        /**
         * Reference to the scrollcontainer that contains the element
         * @type {null|object}
         */
        relatedScrollContainer: null,

        /**
         * Reference for attached event listener
         * @type {Array}
         */
        eventListener: [],

        /**
         * Indicator for hold setTimeout event
         * @type {null|object}
         */
        holdTimeout: null,

        /**
         * Counter for internal drag elemnts
         * @type {number}
         */
        idCounter: 1,

        /**
         * Initializes the functionality for this plugin
         */
        init: function () {
            // Set event handlers with 'this' binding
            this._defineCorrectHandlers()
                ._attachEventHandlers();

            // Scrollcontainer to watch
            if (this.options.scrollContainer.length) {
                this.options.scrollContainer.forEach(function(selector) {
                    var $element = $(selector);
                    this.scrollContainer.push($element);
                    if ($.contains($element[0], this.el)) {
                        this.relatedScrollContainer = $element;
                    }
                }.bind(this));
            }
        },

        /**
         * Destroys the plugin
         */
        destroy: function() {
            this.reset();
            this._destroyEventHandlers();

            // Remove data stuff
            if (this.options.delegate && typeof this.options.delegate === 'string') {
                this.$el.find(this.options.delegate).each(function(idx, drag) {
                    drag = $(drag);

                    if (drag.data() && drag.data('humansdrag-id')) {
                        drag.removeData('humansdrag-id');
                    }
                });
            } else {
                if (this.$el.data() && this.$el.data('humansdrag-id')) {
                    this.$el.removeData('humansdrag-id');
                }
            }

            $.removeData(this.$el, "plugin_" + this._name);
        },

        /**
         * Enables the DND functionality
         * @returns {humansDrag}
         */
        enable: function() {
            this.enabled = true;
            this.options.onEnable.call(this, this);
            return this;
        },

        /**
         * Disables DND
         * @returns {humansDrag}
         */
        disable: function() {
            this.enabled = false;
            this._clearAllHelper();
            this.options.onDisable.call(this, this);
            return this;
        },

        /**
         * Resets the states and deattaches mousevents
         */
        reset: function() {
            var element = this.getTargetElement();

            this.isUsingTouch = this.wasDropped = false;
            this._destroyMouseHandlers();
            this.startPosition = this.currentPosition = null;
            this.setState(this.STATES.IDLE);

            // Deactivate active element
            win.setTimeout(function() {
                this._enableLink(element);
                this.dragEl = this.$dragEl = null;
            }.bind(this), 100);
        },

        /**
         * Checks if the drag could be dropped, when it has a dropThreshold
         * @returns {boolean} True, if drag could be dropped
         */
        couldDrop: function() {
            var state = true;
            if (this.options.dropThreshold > 0) {
                var movement = this.getAbsoluteMovement();
                state = movement.x + movement.y >= this.options.dropThreshold;
            }

            return state;
        },

        /**
         * Sets a new state for the interaction
         * @param {string} state The new State to set
         * @returns {Plugin}
         */
        setState: function(state) {
            // State really changed?
            if (state !== this.state) {
                // Trigger state changed event
                this.$el.trigger({
                    type: 'statechanged.humans.drag',
                    stateBefore: this.state,
                    stateNow: state
                });

                this.state = state;
            }

            return this;
        },

        /**
         * Returns the current state
         * @returns {string}
         */
        getState: function() {
            return this.state;
        },

        /**
         * Sets the startposition for an element
         * @param data
         */
        setStartPosition: function(data) {
            this.startPosition = this.currentPosition = this._getPositionFromData(data);
            this._startInteraction(data.event, data);
        },

        /**
         * Updates the position of the drag element
         * @param {object} e    The event object
         * @param {object} data The data object
         */
        updatePosition: function(e, data) {
            if (this.enabled) {
                var exec = true,
                    t = new Date().getTime();

                if (this.throttle > 0) {
                    exec = t - this.throttleTime >= this.throttle;
                }

                if (exec) {
                    this.currentPosition = this._getPositionFromData(data);
                    this._updateDrag(e, data);
                    this.throttleTime = t;
                }
            }
        },

        /**
         * Creates the helper for the dragprocess
         * @returns {*|HTMLElement}
         * @private
         */
        _createHelper: function() {
            var o = this.options,
                helper = $.isFunction(o.helper)
                    ? $(o.helper.apply(this.element[0], [event]))
                    : (o.helper === "clone"
                    ? this.getTargetElement().clone().removeAttr("id")
                    : this.getTargetElement());

            if (!helper.parents("body").length) {
                helper.appendTo((o.helperContainer === "parent" ? this.el.parentNode : o.helperContainer));
            }

            // Additional class for the drag helper
            if (o.helperClass) {
                helper.addClass(o.helperClass);
            }

            // Check if the helper has absolute positiong
            if (helper[0] !== this.getTargetElement(false) && !(/(fixed|absolute)/).test(helper.css("position"))) {
                helper.css("position", "absolute");
            }

            // Set initial position of clone
            this._cacheMargins();
            var offsetPosition = this.getTargetElement().offset();
            helper.css({
                position : 'absolute',
                zIndex   : 9999,
                top      : offsetPosition.top - this.margins.top + o.offset[0] + 'px',
                left     : offsetPosition.left - this.margins.left + o.offset[1] + 'px',
            });

            // Keep original size?
            if (o.keepSize) {
                helper.css({
                    width: this.getTargetElement().css('width'),
                    height: this.getTargetElement().css('height')
                });
            }

            // Set data value to helper
            //helper.data('state', 'active');
            helper.data('humansdrag-id', this.getTargetElementId());

            return helper;
        },

        /**
         * Clears the drag helper
         * @param {number} dragId ID of the drag to remove or -1 to remove all drags
         * @private
         */
        _clearHelper: function(dragId) {
            var removed = [];
            this.helper.forEach(function(helper) {
                if (helper.data('humansdrag-id') === dragId || dragId < 0) {
                    helper.off().remove();
                    removed.push(helper);
                }
            }.bind(this));

            // Remove destroyed from array
            if (removed.length) {
                removed.forEach(function(helper) {
                    var helperIdx = this.helper.indexOf(helper);
                    if (helperIdx > -1) {
                        this.helper.splice(helperIdx, 1);
                    }
                }.bind(this));
            }
        },

        /**
         * Removes all helper
         * @private
         */
        _clearAllHelper: function() {
            this._clearHelper(-1);
        },

        /**
         * Returns the active helper
         * @param {string=} state (Optional) state of the helper
         * @private
         */
        _getHelper: function(dragId) {
            dragId = dragId || this.getTargetElementId();

            var validHelper = null;

            this.helper.forEach(function(helper) {
                // Take first, that fits state
                if (!validHelper && helper.data('humansdrag-id') === dragId) {
                    validHelper = helper;
                }
            }.bind(this));

            // No valid helper found? Take first of collection
            if (!validHelper) {
                this.helper.forEach(function(helper) {
                    validHelper = helper;
                }.bind(this));
            }

            return validHelper;
        },

        /**
         * Caches the margin for correct positioning
         * @private
         */
        _cacheMargins: function() {
            this.margins = {
                left: (parseInt(this.getTargetElement().css("marginLeft"), 10) || 0),
                top: (parseInt(this.getTargetElement().css("marginTop"), 10) || 0),
                right: (parseInt(this.getTargetElement().css("marginRight"), 10) || 0),
                bottom: (parseInt(this.getTargetElement().css("marginBottom"), 10) || 0)
            };
        },

        /**
         * Starts the drag and drop interaction
         *
         * @param {Object}   event The touch start or click event
         * @param {object}   data  Additional data
         * @param {boolean=} loop  Do we have a loop call?
         * @private
         */
        _startInteraction: function(event, data, loop) {
            loop = loop || false;

            // Apply callback if we don't have a loop call
            if (!loop) {
                this.options.onInteractionStart.call(this, event, this, this.getTargetElement());
            }

            // Set State to interaction
            if (this.getState() === this.STATES.IDLE && !loop) {
                this.setState(this.STATES.INTERACTION);
            }

            if (this.holdTimeout) {
                window.clearTimeout(this.holdTimeout);
            }

            // Check hold event
            this.holdTimeout = window.setTimeout(function() {
                // Is state still interaction? Otherweise do nothing
                if (this.getState() === this.STATES.INTERACTION) {
                    event.preventDefault();

                    var movement = this.getAbsoluteMovement();

                    if (this.isUsingTouch) {
                        if (movement.x + movement.y <= this.options.touchHoldThreshold) {
                            this._initDrag(event, data);
                        } else {
                            this.reset();
                        }
                    } else {
                        if (movement.x + movement.y >= this.options.mouseHoldThreshold) {
                            this._initDrag(event, data);
                        } else {
                            this._startInteraction(event, data, true);
                        }
                    }
                }
            }.bind(this), this.isUsingTouch ? this.options.holdTimeoutTouch : this.options.holdTimeoutMouse);
        },

        /**
         * Initializes the drag
         * @param data
         * @private
         */
        _initDrag: function(event, data) {
            event.preventDefault();

            // Clear previous timeout
            if (this.holdTimeout) {
                window.clearTimeout(this.holdTimeout);
            }

            if (data.delegateTarget) {
                this.setTargetElement(data.delegateTarget);
            }

            // Set new state
            this.setState(this.STATES.DRAG);

            // Remove link
            this._disableLink();

            // Make vibrate response
            if (this.options.vibrateTime > 0 && window.navigator.vibrate) {
                window.navigator.vibrate(this.options.vibrateTime);
            }

            // Create a uniquiq ID for drag elment
            if (!this.getTargetElement().data('humansdrag-id')) {
                this.getTargetElement().data('humansdrag-id', this.idCounter);
                this.idCounter++;
            }

            // Create dragging helper
            this.helper.push(this._createHelper());

            // Add drag element to manager
            if (win.Humans.DndManager) {
                win.Humans.DndManager.dragStart(data.originalEvent, this);
                win.Humans.DndManager.setDragElement(this);
            }

            // Apply callback
            this.options.onDragStart.call(this, event, this, this.getTargetElement(), this._getHelper());

            // Save scroll position if drag is part of scrollcontainer
            if (this.relatedScrollContainer) {
                this.scrollOffset = this.relatedScrollContainer.scrollTop();
            }
        },

        /**
         * Updates the drag
         * @param e
         * @param data
         * @private
         */
        _updateDrag: function(e, data) {
            var o = this.options;

            // Currently dragging?
            if (this.getState() === this.STATES.DRAG) {
                if (win.Humans.DndManager) {
                    var isOver = win.Humans.DndManager.drag(e, this);
                    if (o.overDropClass && this._getHelper()) {
                        if (isOver) {
                            this._getHelper().addClass(o.overDropClass);
                            this.options.onOverDrop.call(this, e, this, this.getTargetElement(), this._getHelper());
                        } else {
                            this._getHelper().removeClass(o.overDropClass);
                        }
                    }
                }

                var move = this.getTotalMovement();
                if (this._getHelper()) {
                    this._getHelper().css({
                        transform: 'translate3d(' + move.x + 'px, ' + move.y + 'px, 0)',
                        userSelect: 'none'
                    });
                }

                // Apply callback
                this.options.onDrag.call(this, e, this, this.getTargetElement(), this._getHelper());
            }
        },

        /**
         * Ends the drag
         * @param e
         * @private
         */
        _endDrag: function(e) {
            var o            = this.options,
                targetDrag   = this.getTargetElement(),
                dragId       = this.getTargetElementId(),
                targetHelper = this._getHelper(dragId);

            // Was dragging before?
            if (this.getState() == this.STATES.DRAG) {
                this.setState(this.STATES.DRAGEND);
                this._destroyMouseHandlers();

                // Was dropped?
                if (win.Humans.DndManager) {
                    this.wasDropped = win.Humans.DndManager.drop(e, this);
                }

                // Was dropped? Trigger callback
                if (this.wasDropped) {
                    this.options.onDrop.call(this, e, this, targetDrag, targetHelper);

                    // Remove over drop class
                    if (o.overDropClass && targetHelper) {
                        targetHelper.removeClass(o.overDropClass);
                    }
                }

                // Call dragend
                this.options.onDragEnd.call(this, e, this, targetDrag, targetHelper);

                // Revert dragelement?
                if (!o.revert) {
                    this._clearHelper(dragId);
                } else {
                    if ((this.wasDropped && o.revertOnDrop) || !this.wasDropped) {
                        if (o.revertClass && targetHelper) {
                            targetHelper.addClass(o.revertClass);
                        }

                        // Add scroll difference
                        var scrollDiff = 0;
                        if (this.relatedScrollContainer) {
                            scrollDiff = this.relatedScrollContainer.scrollTop() - this.scrollOffset;
                        }

                        if (targetHelper) {
                            targetHelper.css({
                                transform: 'translate3d(' + (this.options.offset[0] * -1) + 'px, ' + ((this.options.offset[1] + scrollDiff) * -1) + 'px, 0)'
                            });
                        }
                    } else if (this.wasDropped && !o.revertOnDrop) {
                        if (o.dropClass && targetHelper) {
                            targetHelper.addClass(o.dropClass);
                        }
                    }

                    // @todo: Implement Vars or transitionEnd event
                    win.setTimeout(function () {
                        this._clearHelper(dragId);
                    }.bind(this), 600);
                }

                // Call dragStop event
                if (win.Humans.DndManager) {
                    win.Humans.DndManager.dragEnd(this, e);
                }

                // Focus the orginal element
                targetDrag.focus();
            }

            // Apply callback
            this.options.onInteractionEnd.call(this, e, this, targetDrag);
            this.reset();
        },

        /**
         * Returns the absolute movement of the dragelement
         * @returns {{x: number, y: number, t: number}}
         */
        getAbsoluteMovement: function() {
            return {
                x: Math.abs(this.currentPosition.x - this.startPosition.x),
                y: Math.abs(this.currentPosition.y - this.startPosition.y),
                t: this.currentPosition.t - this.startPosition.t,
            };
        },

        /**
         * Returns the total movement of the dragelement
         * @returns {{x: number, y: number}}
         */
        getTotalMovement: function() {
            return {
                x: this.currentPosition.x - this.startPosition.x,
                y: this.currentPosition.y - this.startPosition.y,
            };
        },

        /**
         * Returns the position from a data object
         * @param {object} data The data from an internal event
         * @returns {{x: number, y: number, t: number}}
         * @private
         */
        _getPositionFromData: function(data) {
            return {
                x: data.x,
                y: data.y,
                xR: data.xR,
                yR: data.yR,
                t: data.t
            };
        },

        /**
         * Defines correct event handlers, so we can deattach them later
         * @returns {Plugin}
         * @private
         */
        _defineCorrectHandlers: function() {
            // Touch events
            this.handlerTouchStart = this.handlerTouchStart.bind(this);
            this.handlerTouchMove = this.handlerTouchMove.bind(this);
            this.handlerTouchEnd = this.handlerTouchEnd.bind(this);
            this.handlerTouchCancel = this.handlerTouchCancel.bind(this);

            // Mouse events
            this.handlerMouseDown = this.handlerMouseDown.bind(this);
            this.handlerMouseMove = this.handlerMouseMove.bind(this);
            this.handlerMouseLeave = this.handlerMouseLeave.bind(this);
            this.handlerMouseUp = this.handlerMouseUp.bind(this);

            // General events
            this.handlerSelectionChange = this.handlerSelectionChange.bind(this);
            this.handlerBlur = this.handlerBlur.bind(this);

            // Prevent handler event
            this.handlerPrevent = this.handlerPrevent.bind(this);

            return this;
        },

        /**
         * Attaches all neccessary event handlers for this element
         * @returns {Plugin}
         * @private
         */
        _attachEventHandlers: function() {
            var delegate = this.options.delegate || '';

            // Bind coument events
            //this._addEventListener(doc.documentElement, 'selectionchange', delegate, this.handlerSelectionChange);

            // Bind touch events
            this._addEventListener(this.el, 'touchcancel', delegate, this.handlerTouchCancel);
            this._addEventListener(this.el, 'touchstart', delegate, this.handlerTouchStart);
            this._addEventListener(this.el, 'touchmove', delegate, this.handlerTouchMove);
            this._addEventListener(this.el, 'touchend', delegate, this.handlerTouchEnd);

            // Bind mouse events
            this._addEventListener(this.el, 'mousedown', delegate, this.handlerMouseDown);

            // Bind prevent handlers
            this._addEventListener(this.el, 'dragstart', delegate, this.handlerPrevent);
            this._addEventListener(this.el, 'drag', delegate, this.handlerPrevent);
            this._addEventListener(this.el, 'dragend', delegate, this.handlerPrevent);

            return this;
        },

        /**
         * Destroys all event handlers
         * @returns {Plugin}
         * @private
         */
        _destroyEventHandlers: function() {
            // Remove possible delegate listener
            if (this.eventListener.length) {
                this.eventListener.forEach(function(listener) {
                    listener['element'].removeEventListener(listener['event'], listener['func']);
                });
            }

            // Destroy mousehandlers
            this._destroyMouseHandlers();

            return this;
        },

        /**
         * Attaches mousehandlers on "mousedown" event
         * @returns {Plugin}
         * @private
         */
        _attachMouseHandlers: function() {
            if (!this.mouseHandlersAttached) {
                this.mouseHandlersAttached = true;
                this._addEventListener(doc.documentElement, 'mouseleave', null, this.handlerMouseLeave);
                this._addEventListener(win, 'mousemove', null, this.handlerMouseMove);
                this._addEventListener(win, 'mouseup', null, this.handlerMouseUp);
                this._addEventListener(win, 'blur', null, this.handlerBlur);
            }

            return this;
        },

        /**
         * Destroys all mousehandlers on "mouseup" event
         * @returns {Plugin}
         * @private
         */
        _destroyMouseHandlers: function() {
            if (this.mouseHandlersAttached) {
                this.mouseHandlersAttached = false;

                doc.documentElement.removeEventListener('mouseleave', this.handlerMouseLeave);
                win.removeEventListener('mousemove', this.handlerMouseMove);
                win.removeEventListener('mouseup', this.handlerMouseUp);
                win.removeEventListener('blur', this.handlerBlur);
            }

            return this;
        },

        /**
         * Wrapper function to add a proper event listener to the given element or delegate element
         * @param {DOMElement} rootElement      The main/root element
         * @param {string}     eventName        Name of the callback
         * @param {string}     delegateSelector Selector for delegating the event
         * @param {function    callback         Callback to apply
         * @private
         */
        _addEventListener: function(rootElement, eventName, delegateSelector, callback) {
            if (delegateSelector && typeof delegateSelector === 'string' && delegateSelector.length) {
                var listenerFunction = function(event) {
                    var possibleTargets = rootElement.querySelectorAll(delegateSelector);
                    var target = event.target;

                    for (var i = 0, l = possibleTargets.length; i < l; i++) {
                        var el = target;
                        var p = possibleTargets[i];

                        while (el && el !== rootElement) {
                            if (el === p) {
                                return callback.call(p, event, p);
                            }

                            el = el.parentNode;
                        }
                    }
                }.bind(this);

                rootElement.addEventListener(eventName, listenerFunction);

                // Add listener to internal array, so we can remove them
                this.eventListener.push({
                    element: rootElement,
                    event: eventName,
                    func: listenerFunction,
                });
            } else {
                rootElement.addEventListener(eventName, callback);

                // Add listener to internal array, so we can remove them
                this.eventListener.push({
                    element: rootElement,
                    event: eventName,
                    func: callback,
                });
            }
        },

        /**
         * Returns the proper target for the DND operation
         * @param {boolean=} getPlain Return jquery object? (Optional
         * @returns {DOMElement|$} The dom element or the jquery representation
         */
        getTargetElement: function(getPlain) {
            return this.dragEl
                ? (getPlain ? this.dragEl : this.$dragEl)
                : (getPlain ? this.el : this.$el);
        },

        /**
         * Returns the ID of the current dragelement
         * @returns {number} ID of the drag element
         */
        getTargetElementId: function() {
            return this.getTargetElement().data() && this.getTargetElement().data('humansdrag-id')
                ? this.getTargetElement().data('humansdrag-id')
                : 0;
        },

        /**
         * Sets the proper DOM Element for DND interaction
         * @param {DOMElement} The proper target to set
         */
        setTargetElement: function(element) {
            this.dragEl = element;
            this.$dragEl = $(element);
        },

        /**
         * This handler prevents a default behavior from the browser.
         * This is needed, because Firefox ignores draggable = false
         * @param {object} event The event to prevent
         */
        handlerPrevent: function(event) {
            event.preventDefault();
        },

        /**
         * Handler for a touch cancel event
         * @param {object} event The touchchancel event
         */
        handlerTouchCancel: function(event) {
            if (this.getState() === this.STATES.DRAG) {
                event.preventDefault();
                this._endDrag(event);
            } else {
                this.reset();
            }
        },

        /**
         * Handler for the blur event on the document
         * @param {object} event The blur event
         */
        handlerBlur: function(event) {
            if (this.getState() === this.STATES.DRAG) {
                event.preventDefault();
                this._endDrag(event);
            } else {
                this.reset();
            }
        },

        /**
         * Is called, when something was selected
         * @param {Object} event The event object.
         */
        handlerSelectionChange: function(event) {
            if (event.cancelable || event.defaultPrevented) {
                if (!this.options.allowTextSelection) {
                    event.preventDefault();
                }
            }

            // Remove selection while interacting
            if (this.getState() === this.STATES.INTERACTION || this.getState() === this.STATES.DRAG) {
                if (win.getSelection) {
                    if (win.getSelection().empty) {  // Chrome
                        win.getSelection().empty();
                    } else if (win.getSelection().removeAllRanges) {  // Firefox
                        win.getSelection().removeAllRanges();
                    }
                } else if (doc.selection) {  // IE?
                    doc.selection.empty();
                }
            }
        },

        /**
         * End drag, when mpouse is leaving
         * @param event
         */
        handlerMouseLeave: function(event) {
            this._endDrag(event);
        },

        /**
         * Handler for the Mousedown event
         * @param {object} event The event object for touchstart
         */
        handlerMouseDown: function(event, delegateTarget) {
            if (!this.isUsingTouch && event.button == 0 && this.enabled) {
                // Attach mouse handlers now
                this._attachMouseHandlers();

                // Define first position
                this.setStartPosition({
                    event: event,
                    x: event.clientX,
                    y: event.clientY,
                    xR: event.clientX,
                    yR: event.clientY,
                    t: event.timeStamp,
                    pointer: this.POINTER_MOUSE,
                    delegateTarget: delegateTarget,
                });
            }
        },

        /**
         * Handler for the TouchStart event
         * @param {object} event The event object for touchstart
         */
        handlerTouchStart: function(event, delegateTarget) {
            if (this.enabled) {
                // Yes we have touch events
                this.isUsingTouch = true;

                // Do we have a single touch? Otherwise, do nothing right now
                if (event.touches.length == 1) {
                    this.setStartPosition({
                        event: event,
                        x: event.touches[0].clientX - window.scrollX,
                        y: event.touches[0].clientY - window.scrollY,
                        xR: event.touches[0].clientX,
                        yR: event.touches[0].clientY,
                        t: event.timeStamp,
                        pointer: this.POINTER_TOUCH,
                        delegateTarget: delegateTarget,
                    });
                }
            }
        },

        /**
         * Handler for mouse move. We will update the position.
         * @param {object} event The mousemove event
         */
        handlerMouseMove: function(event) {
            // We will prevent default behaviour, when item is dragged
            if (this.getState() === this.STATES.DRAG) {
                event.preventDefault();
            }

            this.updatePosition(event, {
                event: event,
                x: event.clientX,
                y: event.clientY,
                xR: event.clientX,
                yR: event.clientY,
                t: event.timeStamp,
                pointer: this.POINTER_MOUSE,
            });
        },

        /**
         * Handler for the touch move. We will update the position.
         * @param {object} event The touchmove event
         */
        handlerTouchMove: function(event) {
            // We will prevent default behaviour, when item is dragged
            if (this.getState() === this.STATES.DRAG) {
                event.preventDefault();
            }

            this.updatePosition(event, {
                event: event,
                x: event.touches[0].clientX - window.scrollX,
                y: event.touches[0].clientY - window.scrollY,
                xR: event.touches[0].clientX,
                yR: event.touches[0].clientY,
                t: event.timeStamp,
                pointer: this.POINTER_TOUCH,
            });
        },

        /**
         * Handler for the Mouseup event. We will end the dragprocess.
         * @param {object} event The moueup event.
         */
        handlerMouseUp: function(event) {
            if (!this.isUsingTouch && event.button === 0) {
                // Prevent default behavior, if state was drag before
                if (this.getState() === this.STATES.DRAG) {
                    event.preventDefault();
                }

                this._endDrag(event);
            }
        },

        /**
         * Handler for touchend event. We will end the dragprocess.
         * @param {object} event The touch end event
         */
        handlerTouchEnd: function(event) {
            if (event.touches.length > 1) {
                this.reset();
            } else {
                // Prevent default behavior, if state was drag before
                if (this.getState() === this.STATES.DRAG) {
                    event.preventDefault();
                }

                this._endDrag(event);
            }
        },

        /**
         * Enables the link of a drag target
         * @param {DomElement=} element The element to change
         * @private
         */
        _enableLink: function(element) {
            element = element || this.getTargetElement();

            if (this.options.preventLinks
                && element.is('a')
                && element.attr('data-href')
            ) {
                var link = element.attr('data-href');
                element.attr('href', link);
                element.removeAttr('data-href');
            }
        },

        /**
         * Dsiables the link of drag target
         * @param {DomElement=} element The element to change
         * @private
         */
        _disableLink: function(element) {
            element = element || this.getTargetElement();

            if (this.options.preventLinks
                && element.is('a')
            ) {
                var link = element.attr('href');
                element.attr('data-href', link);
                element.removeAttr('href');
            }
        },
    });

    /* Definition of Drop
     ------------------------------------------------------------------------------------------------------------------ */
    var pluginNameDrop = "humansDrop",
        defaultsDrop = {
            scope: 'default',
            accept: '*',
            tolerance: 'intersect',
            refreshPosDim: true,
            overClass: false,

            // Callback
            onEnter: function(e, humansDrop, humansDrag, element) { /* Stub for callback */ },
            onOver: function(e, humansDrop, humansDrag, element) { /* Stub for callback */ },
            onDrop: function(e, humansDrop, humansDrag, element) { /* Stub for callback */ },
            onLeave: function(e, humansDrop, humansDrag, element) { /* Stub for callback */ },
        };

    // The actual plugin constructor
    function humansDrop(element, options) {
        // Ref to elements
        this.el   = element;
        this.$el  = $(element);

        // Settings
        this.options   = $.extend({}, defaultsDrop, options);
        this._defaults = defaultsDrop;
        this._name     = pluginNameDrop;

        // call init
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(humansDrop.prototype, {
        /**
         * Offsets of the dropelement
         * @type {object}
         */
        offset: {top: 0, left: 0},

        /**
         * Dimensions of the dropelement
         * @type {object}
         */
        dimensions: {w: 0, l: 0},

        /**
         * States, if a humansdrag is over the element
         * @type {boolean}
         */
        isOver: false,

        /**
         * States if a humansdrag was dropped
         * @type {boolean}
         */
        isDropped: false,

        /**
         * Initializes the humansDrop
         */
        init: function() {
            // Deine accept function
            this.accept = $.isFunction(this.options.accept) ? this.options.accept : function(drop, drag) {
                return !this.options.accept || this.options.accept === '*' || $(drag).is(this.options.accept);
            }.bind(this);

            this._renewPosAndDimension()
                ._addToManager(this.options.scope);
        },

        /**
         * Destroys the plugin on the element
         */
        destroy: function() {
            // Remove from dnd manager
            if (win.Humans.DndManager) {
                var drops = win.Humans.DndManager.droppables[ this.options.scope ] || [];
                for (var i = 0; i < drops.length; i++ ) {
                    if (drops[i] === this) {
                        drops.splice( i, 1 );
                    }
                }
            }

            $.removeData(this.$el, "plugin_" + this._name);
        },

        /**
         * Adds the draggable to the DndManager
         * @param {string} scope The scope of the droppable
         * @returns {HumansDrop}
         * @private
         */
        _addToManager: function(scope) {
            if (win.Humans.DndManager) {
                win.Humans.DndManager.droppables[scope] = win.Humans.DndManager.droppables[scope] || [];
                win.Humans.DndManager.droppables[scope].push(this);
            }

            return this;
        },

        /**
         * Renews the position and the dimensions of the draggable
         * @returns {HumansDrop}
         * @private
         */
        _renewPosAndDimension: function() {
            this.offset = this.$el.offset();
            this.dimensions = {w: this.el.offsetWidth, h: this.el.offsetHeight};
            return this;
        },

        /**
         * Is called from the DndManager, if a humansDrag enters the humansDrop
         * @param {object} e The event, that caused this call
         * @private
         */
        _enter: function(e) {
            var humansDrag = win.Humans.DndManager.currentDrag;

            // Do we accept the drag?
            if (this.accept(this.el, humansDrag.getTargetElement(true))) {

                // Set new state
                this.isOver = true;
                this.isDropped = false;

                // Apply extra class if present
                if (this.options.overClass) {
                    this.$el.addClass(this.options.overClass);
                }

                // Call callback
                this.options.onEnter.call(this, e, this, humansDrag, this.$el);

                // Trigger event
                this.$el.trigger({
                    type: 'enter.humans.drop',
                    event: e,
                    humansDrag: humansDrag,
                    humansDrop: this
                });
            }
        },

        /**
         * Is called from the DndManager, if a humansDrag enters the humansDrop
         * @param {object} e The event, that caused this call
         * @private
         */
        _over: function(e) {
            var humansDrag = win.Humans.DndManager.currentDrag;

            // Do we accept the drag?
            if (this.accept(this.el, humansDrag.getTargetElement(true))) {

                // Call callback
                this.options.onOver.call(this, e, this, humansDrag, this.$el);

                // Trigger event
                this.$el.trigger({
                    type: 'over.humans.drop',
                    event: e,
                    humansDrag: humansDrag,
                    humansDrop: this
                });

            }
        },

        /**
         * Is called from the DndManager, if a humansDrag leaves the humansDrop
         * @param {object} e The event, that caused this call
         * @private
         */
        _leave: function(e) {
            var humansDrag = win.Humans.DndManager.currentDrag;

            // Set new state
            this.isOver = false;

            // Do we accept the drag?
            if (this.accept(this.el, humansDrag.getTargetElement(true))) {

                // Is over class defined?
                if (this.options.overClass) {
                    this.$el.removeClass(this.options.overClass);
                }

                // Call callback
                this.options.onLeave.call(this, e, this, humansDrag, this.$el);

                // Trigger event
                this.$el.trigger({
                    type: 'leave.humans.drop',
                    event: e,
                    humansDrag: humansDrag,
                    humansDrop: this
                });
            }
        },

        /**
         * Drop method, that is called from DndManager. It will return true, if the drop was valid
         * @param {object} e The event, that caused this call
         * @returns {boolean} True, if the drop was valid. Otherwise false.
         * @private
         */
        _drop: function(e) {
            var humansDrag = win.Humans.DndManager.currentDrag,
                valid = false;

            // Set new state
            this.isOver = false;
            this.isDropped = true;

            // @todo: Handle nested drops

            if (this.accept(this.el, humansDrag.getTargetElement(true))) {

                // Is over class defined?
                if (this.options.overClass) {
                    this.$el.removeClass(this.options.overClass);
                }

                // Call callback
                this.options.onDrop.call(this, e, this, humansDrag, this.$el);

                // Trigger event
                this.$el.trigger({
                    type: 'leave.humans.drop',
                    event: e,
                    humansDrag: humansDrag,
                    humansDrop: this
                });

                valid = true;
            }

            return valid;
        },
    });

    // Register Plugins
    $([{
        name: 'humansDrag',
        func: humansDrag
    }, {
        name: 'humansDrop',
        func: humansDrop
    }]).each(function(i, plugin) {
        $.fn[plugin.name] = function (options) {
            var args = arguments;
            if (options === undefined || typeof options === 'object') {
                return this.each(function () {
                    if (!$.data(this, 'plugin_' + plugin.name)) {
                        $.data(this, 'plugin_' + plugin.name, new plugin.func(this, options));
                    }
                });
            } else if (typeof options === 'string' && options[0] !== '_' && options !== 'init') {
                var returns;
                this.each(function () {
                    var instance = $.data(this, 'plugin_' + plugin.name);
                    if (instance instanceof plugin.func && typeof instance[options] === 'function') {
                        returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
                    }
                });
                return returns !== undefined ? returns : this;
            }
        };
    });
})(jQuery, window, document);